<template>
    <span>
        <el-autocomplete 
            class="filterItem-value"
            v-if="showInput"
            :debounce="350"
            v-model="filterItem.value[0]"
            :fetch-suggestions="querySearch"
            clearable
            placeholder="输入关键字"
        />
        <el-select 
            class="filterItem-value"
            v-if="showMultSelect"
            v-model="filterItem.value"
            collapse-tags
            collapse-tags-tooltip
            :filter-method="selectFilter"
            multiple
            filterable>
            <el-option
                v-for="item in queryOptions"
                :key="item.value"
                :label="item.value"
                :value="item.value"
                />
        </el-select>
    </span>
</template>

<style>
    
</style>

<script>
    import baseFilter from "../../BaseFilter"
    import { getGroupResultByKey } from '@/apis/httpHelper';
    import { qweIsEmpty } from '@/common/commonHelper';

    export default {
        name:"TextFieldFilter",
        mixins:[baseFilter],
        data:function(){
            return {
                queryOptions:[]
            }
        },

        methods:{
            selectFilter:function(queryString){
                this.querySearch(queryString,(data) => this.queryOptions = data)
            },
            querySearch:function(queryString,cb){
                if(qweIsEmpty(queryString)){
                    return;
                }
                let fieldName = this.contentDefinition.Name;
                let filter = JSON.stringify({
                    "logic":"and",
                    "filters":[{
                        "field": fieldName,
                        "operator": "contains",
                        "value": queryString
                    }]
                })
                getGroupResultByKey(this.contentType, filter, fieldName)
                .then(x=>{
                    let data = x.Result;
                    cb(data.map(x=>{return { value:x }}));
                })
            }
        }
    }
</script>